import { render, staticRenderFns } from "./EmpresasList.vue?vue&type=template&id=31370f98&scoped=true&"
import script from "./EmpresasList.vue?vue&type=script&lang=js&"
export * from "./EmpresasList.vue?vue&type=script&lang=js&"
import style0 from "./EmpresasList.vue?vue&type=style&index=0&id=31370f98&lang=scss&scoped=true&"
import style1 from "./EmpresasList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31370f98",
  null
  
)

export default component.exports